<template>
  <div>
    <div class="vx-row">
      <div v-if="nenhumProdutoEncontrado === false" class="vx-col w-full mb-2">
        <h5 class="mt-3 mb-6 text-center">Produtos a Serem Atualizados</h5>

        <table class="table-bordered">
          <tr>
            <th></th>
            <th class="w-1/2">Produtos</th>
            <!-- <th class="w-1/5">Valor</th> -->
            <!-- <th class="">Desconto(%)</th>
            <th class="text-center">Cupom Desconto(%)</th> -->

            <!-- SEGURADORA -->
            <th>Prêmio Liquido</th>
            <th>IOF</th>
            <th>Prêmio Total</th>

            <!-- <th class="w-1/5">Valor Final</th> -->
          </tr>
          <tr
            v-for="(item, index) in listProdutosObrigatorios"
            :key="'Obri' + index"
          >
            <td>
              <vs-checkbox
                v-model="form.produtosSelecionados"
                :vs-value="item"
                :disabled="validaSelecionado(item)"
                @input="selecionaProduto(item)"
              >
              </vs-checkbox>
            </td>
            <td>{{ item.nomeProduto }}</td>

            <!-- SEGURADORA -->
            <td>{{ (item.valorPremioLiquido * 12) | currency }}</td>
            <td>{{ (item.valorIOF * 12) | currency }}</td>
            <td>{{ (item.valorFinal * 12) | currency }}</td>

            <!-- <td>
              <div class="flex justify-between items-center">
                <div class="text-center">{{ item.valor | currency }}</div>
                <vs-button
                  v-if="item.alterarValor && AlterarValorProduto"
                  radius
                  v-tooltip="'Alterar o Valor do Produto'"
                  color="success"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-plus"
                  @click="
                    (novoValorProduto = item),
                      (mostrarModalNovoValorProduto = true)
                  "
                ></vs-button>
              </div>
            </td> -->
            <!-- <td>
              <div class="flex justify-between items-center">
                <div>
                  {{ Math.round(item.descontoConcedido).toFixed(2) }}
                  %
                </div>
                <vs-button
                  v-if="PodeDarDesconto && item.porcentagemDescontoMaxima"
                  radius
                  v-tooltip="'Dar Desconto'"
                  color="dark"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-percent"
                  @click="abrirModalDesconto(item)"
                ></vs-button>
              </div>
            </td>
            <td>
              {{ Math.round(item.valorDescontoCupomExibicao || 0).toFixed(2) }}%
            </td> -->
            <!-- <td class="p-4">{{ item.valorFinal | currency }}</td> -->
          </tr>
          <tr>
            <td colspan="6">
              <hr class="my-3"/>
            </td>
          </tr>
          <tr
            v-for="(item, index) in listProdutosNaoObrigatorios"
            :key="'NObri' + index"
          >
            <td>
              <vs-checkbox
                @input="selecionaProduto(item)"
                v-model="form.produtosSelecionados"
                :vs-value="item"
              >
              </vs-checkbox>
            </td>
            <td>{{ item.nomeProduto }}</td>

            <!-- SEGURADORA -->
            <td>{{ (item.valorPremioLiquido * 12) | currency }}</td>
            <td>{{ (item.valorIOF * 12) | currency }}</td>
            <td>{{ (item.valorFinal * 12) | currency }}</td>

            <!-- <td>
              <div class="flex justify-between items-center"></div>
              <div>{{ item.valor | currency }}</div>
              <vs-button
                v-if="item.alterarValor && AlterarValorProduto"
                radius
                v-tooltip="'Alterar o Valor do Produto'"
                color="success"
                type="gradient"
                icon-pack="feather"
                icon="icon-percent"
                @click="
                  (novoValorProduto = item),
                    (mostrarModalNovoValorProduto = true)
                "
              ></vs-button>
            </td>
            <td>
              <div class="flex justify-between items-center">
                <div>{{ item.descontoConcedido }} %</div>
                <vs-button
                  v-if="PodeDarDesconto && item.porcentagemDescontoMaxima"
                  radius
                  v-tooltip="'Dar Desconto'"
                  color="dark"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-percent"
                  @click="abrirModalDesconto(item)"
                ></vs-button>
              </div>
            </td>
            <td>{{ item.valorDescontoCupomExibicao || 0 }}%</td>
            <td>
              {{ item.valorFinal | currency }}
            </td> -->
          </tr>
        </table>

        <!-- SEGURADORA -->
        <div class="text-right">
          <h6 class="mt-5">
            PRÊMIO TOTAL GERAL:
            {{ (somaValorTotalMesAtualizados() * 12) | currency }}
          </h6>
        </div>

        <!-- <h6 class="mt-5">
          Total Mensal: {{ somaValorTotalMesAtualizados() | currency }}
        </h6>
        <h6 class="mt-5">
          Total Entrada: {{ somaValorTotalAtualizados() | currency }}
        </h6> -->

        <!-- Carregamentos -->
        <CarregamentosForm
          v-if="formFiltro.carregamentos"
          :formData="formFiltro"
          @recalcular="recalcularValorProdutos = true"
        />
        <!-- Carregamentos -->
      </div>

      <div v-else class="vx-col w-full mb-2">
        <vs-alert
          title="Atenção"
          active="true"
          color="danger"
          style="max-height: 220px !important"
        >
          Nenhum produto encontrado para esse veículo, revise os dados do
          veículo
        </vs-alert>
      </div>

      <div class="vx-col w-full">
        <ErrorsAlert :errors="errors"/>
      </div>
    </div>

    <!-- botão salvar -->
    <div v-if="!finalizada" class="row mt-5 text-right">
      <div class="">
        <vs-button
          v-if="recalcularValorProdutos"
          color="primary"
          @click.stop.prevent="buscaProdutos"
          type="gradient"
          class="mt-2 mb-2 mr-2"
        >Recalcular valor dos produtos
        </vs-button
        >
        <vs-button
          color="success"
          class="mr-3 mb-2"
          @click="salvaAlteracoesProduto"
          :disabled="recalcularValorProdutos"
        >Salvar Alterações
        </vs-button
        >
      </div>
    </div>
    <div>
      <Modal
        class="holamundo"
        :title="titleSideBar"
        :active.sync="modalDesconto"
      >
        <formDesconto
          :key="contFormDesconto"
          :dados="item"
          :contador="contFormDesconto"
          :modal="modalDesconto"
          @salvarDesconto="salvaItemValor"
        >
        </formDesconto>
      </Modal>
    </div>
    <div>
      <Modal
        id="meu-popup-personalizado2"
        class="holamundo"
        :title="'Novo Valor Produto'"
        :active.sync="mostrarModalNovoValorProduto"
      >
        <FormNovoValorProduto
          v-if="mostrarModalNovoValorProduto"
          :produto="novoValorProduto"
          @close="mostrarModalNovoValorProduto = false"
        ></FormNovoValorProduto>
      </Modal>
    </div>
  </div>
</template>

<script>
const {TIPO_APOLICE} = require('./../../../common/constant/tipo_apolice');
import service from '../../services';
import locale from '../../locale';
import formDesconto from './formDesconto.vue';
import FormNovoValorProduto from './FormNovoValorProduto.vue';
import functions from '../../utils/functions.js';
import notify from '../../utils/notify.js';
import CarregamentosForm from '../menu/nova-cotacao-seguradora/components/carregamentosForm.vue';
import NCSv2_utils from '../menu/nova-cotacao-seguradora/utils';
import ErrorsAlert from '../../components/ErrorsAlert.vue';
import Modal from '../../components/Modal.vue';

export default {
  props: ['dadosProposta', 'formulario', 'precisaAlterarProduto'],
  watch: {
    dadosProposta() {
      this.preencheForm();
    },
    precisaAlterarProduto(newValue) {
      if (newValue) this.formataFormBusca();
    },
  },
  computed: {
    finalizada() {
      const {idStatus, nomeStatus} = this.dadosProposta;
      return idStatus === 4 && nomeStatus === 'Finalizada';
    },
    AlterarValorProduto() {
      const bemProtege = functions.verificaEmpresaBemProtege(
        this.formFiltro.idEmpresa,
      );
      if (bemProtege) {
        return true;
      } else {
        return false;
      }
    },
    errors() {
      return this.$validator.errors.all();
    },
  },
  components: {
    formDesconto,
    FormNovoValorProduto,
    CarregamentosForm,
    ErrorsAlert,
    Modal
  },
  data() {
    return {
      TIPO_APOLICE: TIPO_APOLICE,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: true,
      },
      produtos: [],
      newProd: null,
      modalValor: false,
      itemValor: null,
      listProdutosObrigatorios: [],
      listProdutosNaoObrigatorios: [],
      mostrarModalNovoValorProduto: false,
      novoValorProduto: {},
      produtosTeste: [],
      modalDesconto: false,
      nenhumProdutoEncontrado: false,
      titleSideBar: 'Desconto',
      item: null,
      contFormDesconto: 0,
      form: {
        idProposta: null,
        produtosAtualizados: null,
        produtosSelecionados: [],
        idTipoDesconto: '',
      },
      formFiltro: {
        idEmpresa: null,
        idGrupo: null,
        valor: 0,
        cidade: '',
        estado: '',
        restricoesSelecionadas: [],
        veiculo: {
          cilindradas: null,
          resultFipe: {},
        },
      },
      recalcularValorProdutos: false,
      utils: NCSv2_utils,
    };
  },
  methods: {
    salvaItemValor(item) {
      this.form.idTipoDesconto = item.idTipoDesconto;

      this.listProdutosNaoObrigatorios.forEach((element) => {
        if (element.id_produto == item.id_produto) {
          element.valorFinal = item.valorFinal;
        }
      });

      this.listProdutosObrigatorios.forEach((element) => {
        if (element.id_produto == item.id_produto) {
          element.valorFinal = item.valorFinal;
        }
      });

      this.form.produtosSelecionados.forEach((element) => {
        if (element.id_produto == item.id_produto) {
          element.valorFinal = item.valorFinal;
        }
      });

      this.form.idTipoDesconto = item.idTipoDesconto;
      this.filtraObrigatorios();
      this.filtraNaoObrigatorios();
      this.modalDesconto = false;
    },
    setDesconto(item) {
      var aux = this.produtos.find((x) => x.id_produto == item.id_produto);
      //aux.descontoConcedido = item.valorDesconto;
      if (item.valorDesconto == 0) {
        aux.valorFinal = item.valor;
        aux.style = null;
      } else {
        // aux.valorFinal =  item.valor - (item.valor * item.valorDesconto) / 100;
        //  = item.valor - (item.valor * item.valorDesconto) / 100;
        aux.style = 'text-decoration: line-through;';
      }
      aux.isDesconto = false;

      this.produtos.forEach((element) => {
        if (element.id == item.id_produto) {
          element.valorFinal = aux.valorFinal;
          element.descontoConcedido = aux.descontoConcedido;
        }
      });
      this.produtoToDesconto = null;
      this.modalDesconto = false;
    },
    abrirModalDesconto(item) {
      this.contFormDesconto = this.contFormDesconto + 1;

      if (item) {
        item.estado = this.formulario.dadosCliente.estado;
        item.tipoProposta = this.formulario.dadosGerais.tipoProposta;
        this.item = item;
        this.modalDesconto = true;
      }
      // this.itemValor = { ...item };
    },
    filtraNaoObrigatorios() {
      return this.listProdutosNaoObrigatorios.filter((x) => x.show != false);
    },
    filtraObrigatorios() {
      return this.listProdutosObrigatorios.filter((x) => x.show != false);
    },
    adicionarProduto() {
      if (this.newProd.id_produto) {
        this.form.produtosSelecionados.push({
          id: this.newProd.id_produto,
          valor: this.newProd.valor,
          nomeProduto: this.newProd.nomeProduto,
          obrigatorio: this.newProd.obrigatorio,
          valorFinal: this.newProd.valor,
          isMensal: this.newProd.ismensal,
          descontoConcedido: 0,
          porcentagemDescontoMaxima: this.newProd.porcentagemDescontoMaxima,

          // SEGURADORA
          valorPremioLiquido: this.newProd.valorPremioLiquido,
          valorIOF: this.newProd.valorIOF,
          franquia: this.newProd.franquia,
          valorSegurado: this.newProd.valorSegurado,
        });

        let array = this.listProdutosNaoObrigatorios;
        for (var i = array.length - 1; i >= 0; i--) {
          if (array[i].id_produto == this.newProd.id_produto) {
            array[i].show = false;
          }
        }
      }
      this.newProd = null;
    },
    deletarProduto(id) {
      let array = this.form.produtosSelecionados;
      for (var i = array.length - 1; i >= 0; i--) {
        if (array[i].id == id) {
          array.splice(i, 1);
        }
      }

      let array2 = this.listProdutosNaoObrigatorios;
      for (let i = array2.length - 1; i >= 0; i--) {
        if (array2[i].id_produto == id) {
          array2[i].show = true;
        }
      }
    },
    calculaValor(item) {
      const descontoConcedido = parseFloat(item.descontoConcedido);
      const porcentagemDescontoMaxima = parseFloat(
        item.porcentagemDescontoMaxima,
      );
      const itemValor = parseFloat(item.valor);
      let valorFinal = 0;

      const descConcedMaiorQpercDescMax =
        descontoConcedido > porcentagemDescontoMaxima;
      if (descConcedMaiorQpercDescMax) {
        item.descontoConcedido = 0;

        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Valor de Desconto excede ao valor Permitido',
          color: 'danger',
        });

        return;
      } else {
        valorFinal = itemValor - (itemValor * descontoConcedido) / 100;

        //this.descontoValor = ((this.dados.valor * this.dados.porcentagemDescontoMaxima) / 100)

        const produtosSelecionados = this.form.produtosSelecionados;
        produtosSelecionados.forEach((element) => {
          if (element.id == item.id) {
            element.valorFinal = valorFinal;
            element.descontoConcedido = descontoConcedido;
          }
        });
        this.form.produtosSelecionados = produtosSelecionados;

        this.listProdutosObrigatorios.forEach((element) => {
          if (element.id == item.id) {
            element.valorFinal = valorFinal;
            element.descontoConcedido = descontoConcedido;
          }
        });

        this.listProdutosNaoObrigatorios.forEach((element) => {
          if (element.id == item.id) {
            element.valorFinal = valorFinal;
            element.descontoConcedido = descontoConcedido;
          }
        });

        item.descontoConcedido = descontoConcedido;
        item.valorFinal = valorFinal;

        this.filtraObrigatorios();
        this.filtraNaoObrigatorios();
        this.$forceUpdate();
      }
    },
    formataMoeda(valor) {
      if (valor != null) return `R$ ${valor} `;
    },
    somaValorTotalMes() {
      var total = 0;
      this.dadosProposta.produtos.forEach((prod) => {
        if (prod.isMensal == true) total = total + prod.valorFinal;
      });
      return total;
    },
    somaValorTotal() {
      var total = 0;
      this.dadosProposta.produtos.forEach((prod) => {
        if (prod.isMensal != true) total = total + prod.valorFinal;
      });
      return total;
    },
    somaValorTotalMesAtualizados() {
      var total = 0;
      this.form.produtosSelecionados.forEach((prod) => {
        if (prod.ismensal == true) total = total + prod.valorFinal;
      });
      return total;
    },
    somaValorTotalAtualizados() {
      var total = 0;
      this.form.produtosSelecionados.forEach((prod) => {
        if (prod.ismensal != true) total = total + prod.valorFinal;
      });
      return total;
    },
    produtosObrigatorios() {
      return this.dadosProposta.produtos.filter((x) => x.obrigatorio == true);
    },
    produtosNaoObrigatorios() {
      return this.dadosProposta.produtos.filter((x) => x.obrigatorio != true);
    },
    atualizarProdutosValorAlterado() {
      const produtosValorAlterado = this.dadosProposta.produtos.filter(
        (produto) =>
          produto.valorOriginal && produto.valor !== produto.valorOriginal,
      );

      if (produtosValorAlterado.length) {
        this.atribuiValorAlteradoAProduto(produtosValorAlterado);
      }
    },
    atribuiValorAlteradoAProduto(produtosValorAlterado) {
      produtosValorAlterado.forEach((pr) => {
        const prodObrig = this.listProdutosObrigatorios.find(
          (p) => +pr.idProduto === +p.id_produto,
        );
        const prodOpc = this.listProdutosNaoObrigatorios.find(
          (p) => +pr.idProduto === +p.id_produto,
        );
        const produto = prodObrig || prodOpc;

        produto.valor = pr.valor;
        produto.valorOriginal = pr.valorOriginal;
        produto.valorFinal = pr.valorFinal;
      });
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    preencheForm() {
      const {idProposta: propsIdProposta} = this.formulario.dadosProduto;

      const {idProposta, produtos} = this.dadosProposta;

      if (propsIdProposta) {
        this.form = this.formulario.dadosProduto;
      }

      if (!propsIdProposta && idProposta) {
        this.form.idProposta = idProposta;
        this.form.produtosSelecionados = produtos;
      }

      this.formataFormBusca();
      this.emitLoadedForm();
    },
    formataFormBusca() {
      const _formFiltro = {
        idEmpresa: null,
        idGrupo: null,
        valor: 0,
        cidade: '',
        estado: '',
        valorTotalConjunto,
        valorCobertura,
        somenteAgregado: null,
        restricoesSelecionadas: [],
        idTipoFipe: {},
        veiculo: {
          cilindradas: null,
          resultFipe: {},
        },
      };

      let resultFipeProp;
      let resultFipeForm;

      const {idEmpresa, idGrupo, valorNf, tipoProposta, valorTotalConjunto} =
        this.dadosProposta;

      const {cidade, estado} = this.dadosProposta.dadosCliente;

      const {
        resultadoFipe = {},
        cilindradas = '',
        valorCobertura,
        valorFipe,
      } = this.dadosProposta.dadosVeiculo;

      const {
        restricoesSelecionadas,
        tipoProposta: tipoPropostaFormulario,
        valorNf: valorNfFormulario,
      } = this.formulario.dadosGerais;

      const {
        veiculo: veiculoFormulario,
        cilindradas: cilindradasFormulario = '',
      } = this.formulario.dadosVeiculo;

      const {cidade: cidadeFormulario = '', estado: estadoFormulario = ''} =
        this.formulario.dadosCliente;

      const {
        dadosVeiculo: {
          valorCobertura: valorCoberturaForm,
          valorFipe: valorFipeForm,
          valorTotalConjunto: valorTotalConjuntoForm,
        },
      } = this.formulario;

      _formFiltro['idEmpresa'] = idEmpresa ? idEmpresa : null;

      _formFiltro['idUsuarioConsultor'] = this.dadosProposta.dadosVendedor
        .idUsuario
        ? this.dadosProposta.dadosVendedor.idUsuario
        : null;

      _formFiltro['valorTotalConjunto'] = valorTotalConjuntoForm
        ? valorTotalConjuntoForm
        : valorTotalConjunto || valorFipeForm || valorFipe || valorNf;

      _formFiltro['valorCobertura'] = valorCoberturaForm
        ? valorCoberturaForm
        : valorCobertura || valorFipeForm || valorFipe || valorNf;

      const isArrRestricoesSelecionadas = Array.isArray(restricoesSelecionadas);
      _formFiltro['restricoesSelecionadas'] = isArrRestricoesSelecionadas
        ? restricoesSelecionadas
        : [];

      const objVeiculoVazio = this._isObjectEmpty(veiculoFormulario);

      if (objVeiculoVazio) {
        _formFiltro['idGrupo'] = idGrupo;
        resultFipeProp = JSON.parse(resultadoFipe);

        if (resultFipeProp) _formFiltro['valor'] = resultFipeProp.preco;

        _formFiltro['cidade'] = cidade ? cidade : '';
        _formFiltro['estado'] = estado ? estado : '';
        _formFiltro.veiculo.cilindradas =
          cilindradas !== null ? cilindradas : '';
        _formFiltro.veiculo.resultFipe = resultFipeProp;
      }

      if (!objVeiculoVazio) {
        resultFipeForm =
          typeof veiculoFormulario.resultFipe === 'string'
            ? JSON.parse(veiculoFormulario.resultFipe)
            : veiculoFormulario.resultFipe;

        _formFiltro['idGrupo'] =
          veiculoFormulario.idGrupo === null
            ? idGrupo
            : veiculoFormulario.idGrupo;

        if (resultFipeForm) {
          _formFiltro['valor'] =
            resultFipeForm.preco === null
              ? resultFipeProp.preco
              : resultFipeForm.preco;

          _formFiltro.veiculo.resultFipe =
            resultFipeForm.preco === null ? resultFipeProp : resultFipeForm;
        }

        _formFiltro['cidade'] =
          cidadeFormulario === null ? cidade : cidadeFormulario;

        _formFiltro['estado'] =
          estadoFormulario === null ? estado : estadoFormulario;

        _formFiltro.veiculo.cilindradas =
          cilindradasFormulario === null ? cilindradas : cilindradasFormulario;

        const resultFipeString = typeof _formFiltro.veiculo.resultFipe;

        _formFiltro.veiculo.resultFipe =
          resultFipeString == 'string'
            ? JSON.parse(_formFiltro.veiculo.resultFipe)
            : _formFiltro.veiculo.resultFipe;
      }

      // substituir o valor da FIPE pelo valor da nota informado na criação da proposta
      if (valorNf > 0)
        _formFiltro.veiculo.resultFipe.preco = this.retornaMoeda(valorNf);

      const formataNfFormulario =
        typeof valorNfFormulario === 'string'
          ? valorNfFormulario.replace('.', '').replace(',', '.')
          : void 0;

      const convertNfFormularioNum = parseFloat(formataNfFormulario);
      const valorNfEditado =
        convertNfFormularioNum > 0 && valorNf !== convertNfFormularioNum;

      //substitui o valor da FIPE pelo valor da nota editado
      if (valorNfEditado)
        _formFiltro.veiculo.resultFipe.preco = convertNfFormularioNum;

      _formFiltro['idGrupo'] = {id: _formFiltro.idGrupo};

      _formFiltro.veiculo.marca = {
        id: _formFiltro.veiculo.resultFipe.id_marca,
      };

      _formFiltro.veiculo.modelo = {
        id: _formFiltro.veiculo.resultFipe.id_modelo,
      };

      _formFiltro['tipoProposta'] =
        tipoPropostaFormulario === null ? tipoProposta : tipoPropostaFormulario;

      _formFiltro.veiculo.codTipoVeiculo =
        this.dadosProposta.dadosVeiculo.codTipoVeiculo;

      _formFiltro.idTipoFipe.id =
        this.dadosProposta.dadosVeiculo.codTipoVeiculo;

      _formFiltro.somenteAgregado = this.dadosProposta.somenteAgregado;

      // Seguradora
      _formFiltro.agravos = this.dadosProposta.agravos;
      _formFiltro.carregamentos = this.dadosProposta.carregamentos;
      _formFiltro.idTipoApolice = this.dadosProposta.idTipoApolice
      _formFiltro.cep = this.dadosProposta.dadosCliente.cep

      // POG dar suporte ao formato antigo dos carregamentos
      if (Array.isArray(_formFiltro.carregamentos)) {
        _formFiltro.carregamentos = this.utils.atribuirCarregamentosForm(
          _formFiltro.carregamentos,
        );
      }

      this.formFiltro = _formFiltro;

      this.buscaProdutos();
    },
    async buscaProdutos() {
      const validado = await this.$validator.validateAll();
      if (!validado) {
        return;
      }

      if (this.dadosProposta.idTipoApolice == TIPO_APOLICE.RCVAT) {
        return;
      }

      return new Promise(async (resolve, reject) => {
        this.$vs.loading();
        this.contadorBuscaProdutos = 0;
        service
          .post('Cotacao', 'BuscaProdutos', this.formFiltro)
          .then((res) => {
            if (res.data.length == 0) {
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: 'Nenhum Produto Encontrado para esse veículo',
                color: 'danger',
              });
              this.nenhumProdutoEncontrado = true;
              reject('Nenhum Produto Encontrado para esse veículo');
            } else {
              this.nenhumProdutoEncontrado = false;

              this.produtos = res.data.produtosVeiculo
                ? res.data.produtosVeiculo
                : res.data;

              this.listProdutosObrigatorios = [];
              this.listProdutosNaoObrigatorios = [];
              this.form.produtosSelecionados = [];

              this.produtos.forEach((element) => {
                // element.valorFinal = element.valor;
                element.descontoConcedido = 0;
                element.id = element.id_produto;

                // Carrega os valores de desconto e valores editados
                // var aux = this.dadosProposta.produtos.find(
                //   (x) => x.idProduto == element.id_produto,
                // );

                // calcula o desconto sobre valor original
                // if (aux) {
                //   const diferencaValor = aux.valor - aux.valorFinal;

                //   if (aux.descontoConcedido) {
                //     element.descontoConcedido = this.calculaPercentulDesconto(
                //       diferencaValor,
                //       aux.valor,
                //     );
                //   }

                //   if (aux.valorDescontoCupom) {
                //     element.valorDescontoCupomExibicao =
                //       this.calculaPercentulDesconto(diferencaValor, aux.valor);

                //     element.valorDescontoCupom = aux.valorDescontoCupom;
                //   }

                //   element.valorFinal = aux.valorFinal;
                // }

                // separa produtos obrigatorios e produtos selecionados
                if (element.obrigatorio == true) {
                  this.listProdutosObrigatorios.push(element);

                  const produtoSelecionado = this.validaSelecionado(element);

                  if (!produtoSelecionado) {
                    this.form.produtosSelecionados.push(element);
                  }
                } else {
                  element.selecionado = true;
                  this.listProdutosNaoObrigatorios.push(element);
                  // this.form.produtosSelecionados.push(element);
                }
              });

              const produtosNaoObrigSelecionados =
                this.produtosNaoObrigatorios();

              // verifica se o item não obrigatorio está selecionado
              produtosNaoObrigSelecionados.forEach((itemNObri) => {
                const _prod = this.produtos.find(
                  (itemProd) => itemNObri.idProduto == itemProd.id_produto,
                );

                const produtoSelecionado = this.validaSelecionado(_prod);

                if (_prod && !produtoSelecionado) {
                  this.form.produtosSelecionados.push(_prod);
                  this.selecionaProduto(_prod);
                }
              });

              this.emitChangedForm(
                'produtosSelecionados',
                this.form.produtosSelecionados,
              );

              this.$emit('ProdutosAtualizados', true);

              localStorage.setItem(
                'formFiltro',
                JSON.stringify(this.formFiltro),
              );
            }

            this.atualizarProdutosValorAlterado();

            if (this.recalcularValorProdutos) {
              this.recalcularValorProdutos = false;
            }

            this.$vs.loading.close();
          })
          .catch((e) => {
            this.$vs.loading.close();
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: e,
              color: 'danger',
            });
            reject(e);
          });
      });
    },
    retornaMoeda(valor) {
      return 'R$ ' + valor;
    },
    buscaProdutosSobrepoeFaltante() {
      var arrFaltante = [];
      this.listProdutosObrigatorios.forEach((element) => {
        var aux = this.form.produtosSelecionados.find(
          (x) => x.id == element.id_produto,
        );
        if (!aux) arrFaltante.push(element);
      });
      if (arrFaltante.length > 0) {
        var arrEncontrou = [];
        arrFaltante.forEach((elementFaltante) => {
          this.form.produtosSelecionados.forEach((element) => {
            var aux = this.produtos.find((x) => x.id_produto == element.id);
            if (aux.sobreporOutrosProdutos) {
              var prodssobreporOutrosProdutos =
                aux.sobreporOutrosProdutos.split(',');
              var aux2 = prodssobreporOutrosProdutos.filter(
                (x) => x == elementFaltante.id_produto,
              );
              if (aux2.length > 0) {
                arrEncontrou.push(aux2[0]);
              }
            }
          });

          if (arrEncontrou.length == 0) {
            this.form.produtosSelecionados.push(elementFaltante);
          }
        });
      }
    },
    validaSelecionado(item) {
      var aux = this.form.produtosSelecionados.filter(
        (x) => x.id == item.id_produto,
      );
      if (item.obrigatorio && aux.length > 0) return true;
      else if (item.obrigatorio && aux.length == 0) return false;
      return false;
    },
    selecionaProduto(item) {
      // sobrepoe produtos
      if (item.sobreporOutrosProdutos) {
        var prodssobreporOutrosProdutos =
          item.sobreporOutrosProdutos.split(',');

        prodssobreporOutrosProdutos.forEach((element) => {
          this.form.produtosSelecionados.forEach((elementSel, index) => {
            if (elementSel.id == element) {
              this.form.produtosSelecionados.splice(index, 1);
            }
          });
        });
      } else {
        this.produtos.forEach((element) => {
          if (element.sobreporOutrosProdutos) {
            var prodssobreporOutrosProdutos =
              element.sobreporOutrosProdutos.split(',');
            var aux = prodssobreporOutrosProdutos.find(
              (x) => x == item.id_produto,
            );
            if (aux) {
              this.form.produtosSelecionados.forEach((selecionado, index) => {
                if (selecionado.id == element.id_produto) {
                  this.form.produtosSelecionados.splice(index, 1);
                }
              });
            }
          }
        });
      }
      this.buscaProdutosSobrepoeFaltante();

      // produtos linkados
      if (item.produtosLinkados) {
        const produtosLinkados = item.produtosLinkados.split(',');

        produtosLinkados.forEach((id) => {
          const produtoLinkado = this.produtos.find(
            (produto) => produto.id_produto == id,
          );

          if (!produtoLinkado) return;

          const existeSelecionado = this.form.produtosSelecionados.find(
            (item) => item.id_produto === produtoLinkado.id_produto,
          );

          if (!existeSelecionado) {
            this.form.produtosSelecionados.push(produtoLinkado);
          } else {
            this.form.produtosSelecionados.forEach((elementSel, index) => {
              if (elementSel.id_produto === produtoLinkado.id_produto)
                this.form.produtosSelecionados.splice(index, 1);
            });
          }
        });
      }

      this.form.produtosSelecionados.forEach((produto) => {
        const produtoEncontrado = this.dadosProposta.produtos.find(
          (findProd) => produto.id_produto === findProd.idProduto,
        );

        if (produtoEncontrado) {
          Object.assign(produto, {
            idTipoPagamentoEmpresa: produtoEncontrado.idTipoPagamentoEmpresa,
            nomePagamento: produtoEncontrado.nomePagamento,
          });
        }
      });
      this.emitChangedForm(
        'produtosSelecionados',
        this.form.produtosSelecionados,
      );
    },
    emitLoadedForm() {
      this.form.produtos = this.produtos;
      this.$emit('loaded', {formulario: 'dadosProduto', ...this.form});
    },
    emitChangedForm(id, value) {
      this.$emit('changed', {formulario: 'dadosProduto', id, value});
    },
    salvaAlteracoesProduto() {
      this.emitLoadedForm();
      this.$emit('salvar');
    },
    _isObjectEmpty(value) {
      const isEmpty =
        value && Object.keys(value).length && value.constructor === Object;

      return !isEmpty;
    },
    calculaPercentulDesconto(diferenca, valorOrginal) {
      return (diferenca / valorOrginal) * 100;
    },
  },
  mounted() {
    this.$validator.localize('ptBr', locale);
  },
};
</script>

<style scoped lang="scss">
.table-bordered {
  display: table;
  border-collapse: separate;
  box-sizing: border-box;
  border-spacing: 2px;
  border-color: grey;
  width: 100%;

  tr td {
    padding: 2px;
  }

  tr:nth-child(2n) {
    background: #efefef !important;
  }
}

.vdp-datepicker input {
  width: 100%;
}

.vs-tabs-primary .activeChild button,
.vs-tabs-primary button:not(:disabled):hover {
  color: #fff !important;
}

.inner-popup {
  z-index: 999999 !important;
}
</style>

<style>
#meu-popup-personalizado2.con-vs-popup .vs-popup {
  width: fit-content;
}
</style>
